module.exports = __webpack_public_path__ + "c13dcac11c7ad9c93ba545ac445a1e7b.svg";